import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-718f9c8a")

_pushScopeId("data-v-718f9c8a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("WeTrade")
const _hoisted_2 = { class: "fill p-r df-col" }
const _hoisted_3 = { class: "fill p-r" }
const _hoisted_4 = {
  key: 0,
  class: "footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_Scroller = _resolveComponent("Scroller")
  const _component_Page = _resolveComponent("Page")

  return (_openBlock(), _createBlock(_component_Page, { class: "with-header" }, {
    default: _withId(() => [
      _createVNode(_component_PageHeader, {
        class: ["px-16", _ctx.headerClass]
      }, {
        title: _withId(() => [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _hoisted_1
          ], {}, true)
        ]),
        left: _withId(() => [
          _renderSlot(_ctx.$slots, "left", {}, undefined, true)
        ]),
        right: _withId(() => [
          _renderSlot(_ctx.$slots, "right", {}, undefined, true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true),
        _renderSlot(_ctx.$slots, "body", {}, () => [
          _createVNode(_component_Scroller, {
            "css-only": "",
            class: "flex-1 operation__dialog-body"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ]),
            _: 3
          })
        ], {}, true),
        (_ctx.useFooter)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
})